import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// components
import Logo from '../components/logo';
// sections
import { LoginForm } from '../sections/auth/login';
import 'bootstrap/dist/css/bootstrap.min.css';
import srmaImg from "../components/images/srma-login-ig.png"
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import WebsiteLoginForm from 'src/sections/auth/login/websiteLoginForm';
import PasswordResetForm from 'src/sections/auth/login/PasswordResetForm';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  background: 'white',
  borderRadius: '10px',
  padding: theme.spacing(5, 5),
}));

const MainContent = styled('div')(() => ({
  backgroundImage: `url(https://img.freepik.com/free-photo/dark-blue-plain-wall-background_53876-92976.jpg)`,
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'local',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  width: '100%',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const location = useLocation();
  const [route, setRoute] = useState("");
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  
    useEffect(() => {
      const path = location.pathname.substring(1);
      setRoute(path);
      setIsPasswordReset(path.startsWith('seller-password-reset') || path.startsWith('forgot-password'));
    }, [location.pathname]);
    
  return (
    <>
      <ToastContainer position='top-right' />
      <Helmet>
        <title> {(isPasswordReset) ? "Reset Password" : "Login"} </title>
      </Helmet>

      <div className='d-flex justify-content-around align-items-center'>
        <div style={{ background: '#010101' }} id='ResponsiveImages' className='w-50 vh-100 d-flex justify-content-center align-items-center'>
          <div>
            <img src={srmaImg} width="100%" />
          </div>
        </div>
        <div className='w-50 d-flex justify-content-center ResponsiveLogin'>
          <div className='w-50 ResponseInput'>
            {(isPasswordReset) ?
              <PasswordResetForm />
            : ((route === 'buyer/login') ? (
              <WebsiteLoginForm />
              ) : (
                <LoginForm />
                )
            )}
          </div>
        </div>
      </div>
    </>
  );
}
